const getters = {
  currentLang: state => state.common.currentLang,
}
export default getters
